/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e,n){return n?e*(1e3/n):0}export{e as velocityPerSecond};
//# sourceMappingURL=velocity-per-second.js.map
